/*
  Shared logic for the report generation dialogs (GenerateDialog,
  MileageGenerateDialog): runs a report mutation, handles the
  { status, errors, result } envelope and refreshes the executed
  reports lists. Expects the component to expose a `dialog` computed
  with a setter that closes the dialog.
*/
export default {
  methods: {
    executeReportMutation ({ mutation, variables, responseKey }) {
      this.$store.commit('setLoading', true)

      return this.$apollo
        .mutate({
          mutation,
          variables,
          fetchPolicy: 'no-cache'
        })
        .then(response => {
          const { status, errors, result } = response.data[responseKey]

          switch (status) {
            case 'OK':
              this.$store.commit('reports/addReport', {
                ...result,
                unitName: this.generateUnitName(result.units)
              }, { root: true })
              this.$store.dispatch('reports/getList')
              this.$store.dispatch('scheduleReports/getList', false, { root: true })
              this.$store.commit('toggleSnackbar', {
                message: this.$i18n.t('reports.start.reports'),
                color: 'success'
              })
              this.dialog = false
              break

            case 'NOTFOUND':
              this.$store.commit('toggleSnackbar', {
                message: 'Theres no brake events for the the date selected',
                color: 'orange darken-2'
              })
              break
            case 'UNPROCESSABLE':
              this.$store.commit('toggleSnackbar', {
                message: errors.days,
                color: 'orange darken-2'
              })
              break

            case 'INTERNALERROR':
              this.$store.commit('toggleSnackbar')
              break
          }
        })
        .catch(_ => {
          this.$store.commit('toggleSnackbar')
        }).finally(() => {
          this.$store.commit('setLoading', false)
        })
    },

    generateUnitName (unitIds) {
      const units = this.$store.state.units.basicList.filter(unit => unitIds.includes(unit.id))
      if (units.length === 0) {
        return 'All Units'
      } else if (units.length >= 4) {
        return `${units.slice(0, 4).map(unit => unit.name).join(', ')}...`
      }
      return units.map(unit => unit.name).join(', ')
    }
  }
}